import { Platform, StyleSheet } from 'react-native';
import Typography from '../../../../shared/constants/Typography';

export const createButtonStyles = (theme: any) =>
  StyleSheet.create({
    base: {
      // Figma: radius 8px, border 1px
      borderRadius: Typography.radius.radius8,
      alignItems: Typography.textAlign.centerAlign,
      justifyContent: Typography.textAlign.centerAlign,
      borderColor: theme.borderColor,
      borderWidth: Typography.borderWidth.borderWidth1,
    },
    fullWidth: {
      width: Typography.fullWidth,
    },

    /* Variants */
    primary: {
      backgroundColor: theme.primaryBG,
      color: theme.primartText,
      borderColor: 'transparent',
    },
    secondary: {
      backgroundColor: theme.secondaryBG,
      borderColor: theme.secondaryBorderColor,
    },
    disabled: {
      backgroundColor: theme.bGDisableColor,
      borderColor: 'transparent',
    },

    /* Sizes */
    small: {
      height: Typography.height.height44,
      paddingHorizontal: Typography.spacing.spacing16,
    },
    medium: {
      // Figma: height 36px, padding 12px
      height: Typography.height.height36,
      paddingHorizontal: Typography.padding.padding24,
    },
    mLarge: {
      height: Typography.height.dropDownheight,
      paddingHorizontal: Typography.spacing.spacing16,
      ...Platform.select({
        web: {
          paddingHorizontal: 0,
        },
      }),
    },
    xlarge: {
      height: Typography.height.dropDownheight,
      paddingHorizontal: Typography.spacing.spacing24,
    },
    large: {
      height: Typography.height.dropDownheight,
      paddingHorizontal: Typography.padding.padding24,
    },
    xs: {
      height: Typography.height.height44,
      paddingHorizontal: Typography.padding.padding12,
    },

    textBase: {
      // Figma: 14px text on 36px buttons
      fontSize: Typography.fontSize.fontSize14,
      fontWeight: Typography.fontWeight.medium,
      textAlignVertical: Typography.textAlign.centerAlign,
      fontFamily: Typography.fontFamily.inter,
      color: theme.CTAIcon,
    },
    textPrimary: {
      color: theme.primartText,
    },
    textSecondary: {
      color: theme.secondaryText,
    },
    textDisabled: {
      color: theme.textDisableColor,
    },
    secondaryHovered: {
      backgroundColor: theme.secondaryHoverBG,
    },
    secondaryPressed: {
      backgroundColor: theme.secondaryPressedBG,
    },
    primaryHovered: {
      backgroundColor: theme.primaryHoverBG,
    },
    primaryPressed: {
      backgroundColor: theme.primaryPressedBG,
    },
    buttonTextContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      ...Platform.select({
        web: {
          alignSelf: 'stretch',
          overflow: 'hidden',
          gap: 8,
        },
      }),
    },
    textTruncate: {
      ...Platform.select({
        web: {
          flexShrink: 1,
        },
      }),
    },
    iconWrapper: {
      ...Platform.select({
        web: {
          flexShrink: 0,
          flexGrow: 0,
        },
      }),
    },
    subTitleBadge: {
      backgroundColor: theme.subTitleBadgeBg,
      paddingHorizontal: Typography.padding.padding6,
      paddingVertical: Typography.padding.padding2,
      borderRadius: Typography.radius.radius8,
      flexShrink: 0,
      marginLeft: Typography.margin.margin4,
      height: Typography.height.height22
    },
    subTitleHoveredBadge: {
       backgroundColor: theme.subTitleBadgeText,
    },
    subTitleText: {
      fontSize: Typography.fontSize.fontSize12,
      fontWeight: Typography.fontWeight.medium,
      fontFamily: Typography.fontFamily.inter,
      color: theme.subTitleBadgeText,
      lineHeight: Typography.fontSize.fontSize16,
    },
  });
